export default __webpack_public_path__ + "static/media/top-news.aeb73aa4.png";